import { render, staticRenderFns } from "./CompareCell.vue?vue&type=template&id=0861c843&scoped=true&"
import script from "./CompareCell.vue?vue&type=script&lang=ts&"
export * from "./CompareCell.vue?vue&type=script&lang=ts&"
import style0 from "./CompareCell.vue?vue&type=style&index=0&id=0861c843&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0861c843",
  null
  
)

export default component.exports